import React from "react";
import { twMerge } from "tailwind-merge";
import { Link as GatsbyLink } from "gatsby";
export interface LinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  linkText: string;
  href: string;
  wrapperClassName?: string;
  isStyleInherited?: boolean;
}

const Link: React.FunctionComponent<React.PropsWithChildren<LinkProps>> = ({
  href,
  linkText,
  wrapperClassName,
  className = "",
  children,
  ...rest
}) => {
  const isExternal = href?.startsWith("http");
  const wrapperDefaultClass = "";
  const linkClassName =
    "text-primary-blue-50 text-sm font-normal underline hover:font-semibold xl:text-base cursor-pointer";

  if (isExternal) {
    return (
      <div className={twMerge(wrapperDefaultClass, wrapperClassName)}>
        <a
          href={href}
          referrerPolicy="no-referrer"
          target="_blank"
          className={twMerge(linkClassName, className)}
          rel="noreferrer"
          {...rest}
        >
          {children ? children : linkText}
        </a>
      </div>
    );
  }

  return (
    <div className={twMerge(wrapperDefaultClass, wrapperClassName)}>
      <GatsbyLink
        to={href}
        {...rest}
        className={twMerge(linkClassName, className)}
      >
        {children ? children : linkText}
      </GatsbyLink>
    </div>
  );
};
export default Link;
